import { startOfMonth } from 'date-fns';
import { OverflowTypeSearch } from 'utils/constants/admin';
import { CampaignSubSource } from 'utils/constants/campaign';
import { SortType } from 'utils/constants/common';

import createReducer, { ActionCreatorHelper } from 'store/createReducer';

type CampaignId = string;
type FromDate = Date;
type ToDate = Date;
type IsLoad = boolean;

interface Overflow {
    apiSource: CampaignSubSource;
    campaignId: number;
    overflow: number;
}

interface Sort {
    key: keyof Overflow;
    sort: SortType;
}

// ----------------------- actions -------------------------------------
const SET_OVERFLOWS_BY_DATES = 'SET_OVERFLOWS_BY_DATES';
const SET_IS_LOAD_OVERFLOWS = 'SET_IS_LOAD_OVERFLOWS';
const SET_DATES_OVERFLOWS = 'SET_DATES_OVERFLOWS';
const SET_CAMPAIGN_ID_OVERFLOWS = 'SET_CAMPAIGN_ID_OVERFLOWS';
const SET_SEARCH_TYPE_OVERFLOWS = 'SET_OVERFLOWS_SEARCH_TYPE';
const SET_SORTS_OVERFLOWS = 'SET_SORTS_OVERFLOWS';

interface PayloadTypes {
    [SET_OVERFLOWS_BY_DATES]: Overflow[];
    [SET_IS_LOAD_OVERFLOWS]: IsLoad;
    [SET_DATES_OVERFLOWS]: { from: FromDate; to: ToDate };
    [SET_CAMPAIGN_ID_OVERFLOWS]: CampaignId;
    [SET_SEARCH_TYPE_OVERFLOWS]: OverflowTypeSearch;
    [SET_SORTS_OVERFLOWS]: Sort[];
}

const ActionCreator = ActionCreatorHelper<PayloadTypes>();

export const setOverflows = ActionCreator(SET_OVERFLOWS_BY_DATES);
export const setLoadOverflows = ActionCreator(SET_IS_LOAD_OVERFLOWS);
export const setDates = ActionCreator(SET_DATES_OVERFLOWS);
export const setCampaignId = ActionCreator(SET_CAMPAIGN_ID_OVERFLOWS);
export const setSearchType = ActionCreator(SET_SEARCH_TYPE_OVERFLOWS);
export const setSorts = ActionCreator(SET_SORTS_OVERFLOWS);
// ----------------------- /actions -------------------------------------

// ----------------------- reducer --------------------------------------
interface OverflowState {
    overflows: Overflow[];
    isLoad: IsLoad;
    from: FromDate;
    to: ToDate;
    campaignId: CampaignId;
    typeSearch: OverflowTypeSearch;
    sorts: Sort[];
}

export const OVERFLOW_INITIAL_STATE: OverflowState = {
    overflows: [],
    isLoad: false,
    from: startOfMonth(new Date()),
    to: new Date(),
    campaignId: '',
    typeSearch: OverflowTypeSearch.Dates,
    sorts: [],
};

export default createReducer<OverflowState, PayloadTypes>(OVERFLOW_INITIAL_STATE, {
    [SET_OVERFLOWS_BY_DATES]: (state, { payload }) => ({
        ...state,
        overflows: payload,
    }),
    [SET_DATES_OVERFLOWS]: (state, { payload }) => ({
        ...state,
        from: payload.from,
        to: payload.to,
    }),
    [SET_IS_LOAD_OVERFLOWS]: (state, { payload }) => ({
        ...state,
        isLoad: payload,
    }),
    [SET_SEARCH_TYPE_OVERFLOWS]: (state, { payload }) => ({
        ...state,
        typeSearch: payload,
    }),
    [SET_CAMPAIGN_ID_OVERFLOWS]: (state, { payload }) => ({
        ...state,
        campaignId: payload,
    }),
    [SET_SORTS_OVERFLOWS]: (state, { payload }) => ({
        ...state,
        sorts: payload,
    }),
});
// ----------------------- /reducer --------------------------------------
